export default "__VITE_ASSET__DWzeykAV__"